import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mapEducationInfoToValues } from '../../../../../../common';

import type { RootState } from '../../../../../../../store';

export default function useEducationInfoInitialValues() {
  const educationInfo = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails?.education_info,
  );

  return useMemo(() => mapEducationInfoToValues(educationInfo), [educationInfo]);
}
